var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8338 6.45351C11.7806 6.39996 11.7174 6.35745 11.6478 6.32844C11.5782 6.29943 11.5035 6.2845 11.4281 6.2845C11.3526 6.2845 11.278 6.29943 11.2083 6.32844C11.1387 6.35745 11.0755 6.39996 11.0224 6.45351L8.40547 9.07043C8.35235 9.12399 8.28915 9.1665 8.21953 9.1955C8.1499 9.22451 8.07522 9.23945 7.99979 9.23945C7.92436 9.23945 7.84967 9.22451 7.78005 9.1955C7.71042 9.1665 7.64722 9.12399 7.59411 9.07043L4.97718 6.45351C4.92406 6.39996 4.86087 6.35745 4.79124 6.32844C4.72161 6.29943 4.64693 6.2845 4.5715 6.2845C4.49607 6.2845 4.42139 6.29943 4.35176 6.32844C4.28213 6.35745 4.21893 6.39996 4.16582 6.45351C4.0594 6.56057 3.99966 6.70539 3.99966 6.85634C3.99966 7.00729 4.0594 7.1521 4.16582 7.25916L6.78846 9.88179C7.10986 10.2028 7.54554 10.3831 7.99979 10.3831C8.45404 10.3831 8.88971 10.2028 9.21111 9.88179L11.8338 7.25916C11.9402 7.1521 11.9999 7.00729 11.9999 6.85634C11.9999 6.70539 11.9402 6.56057 11.8338 6.45351Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.deaa24a4d0527f2a3b6773880203df1b.svg";
export { ForwardRef as ReactComponent };